module.exports = __webpack_public_path__ + "static/media/report2019.04550184.pdf";